import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { usePlaidLink } from 'react-plaid-link'
import axios from 'axios'
import { Button, notification } from 'antd'
import { addAuthToken } from '@apis/helper'
import { putPaymentMethod } from '@reducers/paymentMethod/paymentMethodSlice'
import { selectCurrentUserCompanyId } from '@reducers/currentUser/currentUserSelectors'
import styles from './LinkBankAccountButton.module.scss'


function LinkBankAccountButton(props) {
  const { buttonType, buttonText, onLinkAccountSuccess, extraOnClick } = props
  const [token, setToken] = useState(null)
  const dispatch = useDispatch()
  const companyId = useSelector(selectCurrentUserCompanyId)

  const onSuccess = useCallback(async (publicToken, metadata) => {
    const payload = {
      plaid_public_token: publicToken,
      plaid_account_id: metadata.account_id,
    }
    const response = await dispatch(putPaymentMethod({ payload, companyId }))
    if (response?.payload?.error) {
      notification.error({ message: response.payload.error })
    } else {
      onLinkAccountSuccess()
    }
  }, [])

  const createLinkToken = React.useCallback(async () => {
    const response = await axios.request(addAuthToken({ url: `${SERVER_BASE_URL}/api/plaid/create-link-token` }))
    setToken(response.data.link_token)
  }, [setToken])

  const config = { token, onSuccess }
  const { open, ready } = usePlaidLink(config)

  useEffect(() => {
    if (token == null) {
      createLinkToken()
    }
  }, [token])

  return (
    <Button
      className={styles.linkBankAccountButton}
      onClick={() => {
        extraOnClick()
        open()
      }}
      disabled={!ready}
      type={buttonType || 'default'}
    >
      {buttonText || 'Link Bank Account'}
    </Button>
  )
}

export default LinkBankAccountButton
